import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementConfigurationDates } from '@api/manageNetworkElementConfigurations';

import { extractQueryParams } from '@utils/common';
import { parseStringDate } from '@utils/date';

import { IAvailableDates } from '@interfaces/common/common';
import { INetworkElementConfigurationIdentifier } from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CONFIGURATION_DATES } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationDatesReturned {
	networkElementConfigurationDates: Date[];
	isLoadingNetworkElementConfigurationDates: boolean;
}

const useQueryNetworkElementConfigurationDates = (
	params: INetworkElementConfigurationIdentifier,
): IUseQueryNetworkElementConfigurationDatesReturned => {
	const {
		middlewareId,
		networkElementId,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IAvailableDates, Date[]>({
		queryKey: [NETWORK_ELEMENT_CONFIGURATION_DATES, params],
		queryFn: extractQueryParams(getNetworkElementConfigurationDates),
		select: (data) => data?.availableDates?.map((date) => parseStringDate(date)) || [],
		enabled: [!!middlewareId, !!networkElementId],
		...refetchOptions,
	});

	return {
		networkElementConfigurationDates: data || [],
		isLoadingNetworkElementConfigurationDates: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementConfigurationDates;
